/**
 * Permission constants organized by module
 * Use these constants instead of hardcoded strings to prevent typos
 */
export const Permissions = {
  Users: {
    View: 'Users.View',
    Create: 'Users.Create',
    Edit: 'Users.Edit',
    Delete: 'Users.Delete',
    ManageRoles: 'Users.ManageRoles',
  },
  WorkOrders: {
    View: 'WorkOrders.View',
    Create: 'WorkOrders.Create',
    Edit: 'WorkOrders.Edit',
    Delete: 'WorkOrders.Delete',
    Approve: 'WorkOrders.Approve',
    ManageFarmers: 'WorkOrders.ManageFarmers',
  },
  Items: {
    View: 'Items.View',
    Create: 'Items.Create',
    Edit: 'Items.Edit',
    Delete: 'Items.Delete',
  },
  Farmers: {
    View: 'Farmers.View',
    Create: 'Farmers.Create',
    Edit: 'Farmers.Edit',
    Delete: 'Farmers.Delete',
  },
  Customers: {
    View: 'Customers.View',
    Create: 'Customers.Create',
    Edit: 'Customers.Edit',
    Delete: 'Customers.Delete',
  },
  Printing: {
    View: 'Printing.View',
    ClaimJobs: 'Printing.ClaimJobs',
    ManageJobs: 'Printing.ManageJobs',
  },
  Settings: {
    View: 'Settings.View',
    Edit: 'Settings.Edit',
  },
  Production: {
    View: 'Production.View',
    Create: 'Production.Create',
    Delete: 'Production.Delete',
  },
  Logistics: {
    ViewRoutes: 'Logistics.ViewRoutes',
    CreateRoutes: 'Logistics.CreateRoutes',
    EditRoutes: 'Logistics.EditRoutes',
    DeleteRoutes: 'Logistics.DeleteRoutes',
    ViewVehicles: 'Logistics.ViewVehicles',
    CreateVehicles: 'Logistics.CreateVehicles',
    EditVehicles: 'Logistics.EditVehicles',
    DeleteVehicles: 'Logistics.DeleteVehicles',
    ViewDrivers: 'Logistics.ViewDrivers',
    CreateDrivers: 'Logistics.CreateDrivers',
    EditDrivers: 'Logistics.EditDrivers',
    DeleteDrivers: 'Logistics.DeleteDrivers',
  },
  Maintenance: {
    Access: 'Maintenance.Access',
  },
  Intakes: {
    Create: 'Intakes.Create',
    PrintLabels: 'Intakes.PrintLabels',
    Confirm: 'Intakes.Confirm',
    View: 'Intakes.View',
    ViewOwn: 'Intakes.ViewOwn',
  },
} as const;

// Type helper to get all permission strings
export type Permission = typeof Permissions[keyof typeof Permissions][keyof typeof Permissions[keyof typeof Permissions]];
